import FilterContainer from '@/components/filters/FilterContainer.jsx';
import { RiMindMap } from '@/components/react-icons/main';
import DividerV2 from '@/components/v2/DividerV2.jsx';
import setQuery from '@/lib/setQuery.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { query } from '@/redux/selectors/querySelectors.js';
import selectors from '@/redux/selectors/selectors.js';
import argumentDataSources from '@/schema/argumentDataSources.js';
import stepActions from '@/screens/workflows/redux/actions/stepActions.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors.js';
import appSchema from '@shared/schema/appSchema.js';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import getFieldOptions from '../argumentsOptionsWrapper/getFieldOptions.js';
import SliderClose from './SliderClose.jsx';
import SliderHeader from './SliderHeader.jsx';
import SliderTitle from './SliderTitle.jsx';

const ConditionSlider = ({ onClose, disabled = false }) => {
  const stepId = useArgSelector(query, 'stepId');
  const appId = useArgSelector(selectors.param, 'appId');
  const apps = useSelector(selectors.appsVersions);
  const steps = useSelector(workflowScreenSelectors.activeWorkflow)?.steps;
  const args = useSelector((state) => workflowScreenSelectors.activeWorkflowStep(state)?.arguments) || {};

  const isOldFormat = !!args?.field || !!args?.operator || !!args?.value;
  const rawConditions = isOldFormat ? { filterSet: [], conjunction: 'and' } : args?.conditions || { filterSet: [], conjunction: 'and' };
  const conditions = { ...rawConditions, filterSet: rawConditions?.filterSet ?? [] };

  const isOpen = useSelector((state) => state?.ui?.argumentOptionSlider?.optionType === 'condition');

  const operatorOptions = appSchema?.api?.filters?.operators?.map((n) => ({ ...n, label: n.shorthand }));
  const fieldOptions = getFieldOptions({ stepId, apps, steps, appId });

  const handleConditionsChange = (newConditions) => {
    stepActions.set('arguments.conditions', newConditions);
  };

  const handleDeleteAll = () => {
    stepActions.set('arguments.conditions', { filterSet: [], conjunction: 'and' });
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      setQuery({ conditionSlider: true });
    } else {
      setQuery({ conditionSlider: undefined });
    }

    return () => {
      setQuery({ conditionSlider: undefined });
    };
  }, [isOpen]);

  return (
    <>
      <SliderHeader onClose={onClose} showDelete showRun onDelete={handleDeleteAll} disabled={disabled} />
      <SliderTitle //
        icon={RiMindMap}
        title="Create Condition"
        description={'Branch your workflow based on a condition.'}
      />
      <FilterContainer //
        disabled={disabled}
        dataSource={argumentDataSources.workflowStep}
        isIfElse={true}
        isTransformAction={false}
        lookupSettings={false}
        filters={conditions}
        fieldOptions={fieldOptions}
        operatorOptions={operatorOptions}
        isAdvanced={true}
        onChange={handleConditionsChange}
      />
      <DividerV2 />
      <SliderClose onClose={onClose} />
    </>
  );
};

export default ConditionSlider;
